export type PxSize = { w: number; h: number };

// Wrap inner artwork (no outer <svg>) in a tight canvas with matching px size and viewBox
export function tightSVG(inner: string, size: PxSize): string {
  return `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${size.w}px" height="${size.h}px" viewBox="0 0 ${size.w} ${size.h}" preserveAspectRatio="xMidYMid meet">\n  ${inner}\n</svg>`.trim();
}

// Extract the content inside the root <svg> and its intrinsic size from viewBox/width/height
export function extractInner(svg: string): { inner: string; w: number; h: number } {
  const openTagMatch = svg.match(/<svg\b[^>]*>/i);
  const closeTagIndex = svg.lastIndexOf("</svg>");
  if (!openTagMatch || closeTagIndex < 0) {
    return { inner: svg, w: 0, h: 0 };
  }
  const open = openTagMatch[0];
  const start = openTagMatch.index! + open.length;
  const inner = svg.substring(start, closeTagIndex).trim();

  // Prefer viewBox
  const vbMatch = open.match(/viewBox\s*=\s*"([^"]+)"/i);
  if (vbMatch) {
    const parts = vbMatch[1].trim().split(/\s+/).map(Number);
    if (parts.length === 4 && isFinite(parts[2]) && isFinite(parts[3])) {
      return { inner, w: parts[2], h: parts[3] };
    }
  }
  // Fallback to width/height
  const widthMatch = open.match(/\bwidth\s*=\s*"([^"]+)"/i);
  const heightMatch = open.match(/\bheight\s*=\s*"([^"]+)"/i);
  const w = widthMatch ? parseFloat(widthMatch[1]) : 0;
  const h = heightMatch ? parseFloat(heightMatch[1]) : 0;
  return { inner, w: isFinite(w) ? w : 0, h: isFinite(h) ? h : 0 };
}


